import React, { useContext, useEffect, useState } from "react";
import CategoryCards from "./CategoryCards/CategoryCards";
import RecentlyVisited from "./RecentlyVisited/RecentlyVisited";
import LandingCarousal from "../../Components/Carousal/LandingCarousal";
import Banner from "./Banner/Banner";
import TopBargains from "./BestDeal/TopBargains";
import BestDeal2 from "./BestDeal/BestDeal2";
import RecentlyVisited2 from "./RecentlyVisited/RecentlyVisited2";
import { UserContext } from "../../Context/UserContext";
import Heading from "../../Components/Heading/Heading";
import Container from "../Container";
import MainPageFeatures from "./MainPageFeatures";
import CategoryFooter from "../Layout/Footer/CategoryFooter";
import Catlog from "./Catlog/Catlog";
import SectDescription from "../../Components/Heading/SectDescription";
import { CartContext } from "../../Context/CartContext";
import { message } from "antd";
import { LoginContext } from "../../Context/LoginContext";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const { isLogin } = useContext(UserContext);

  const [data, setData] = useState([]);
  const [SkeletonLoad, setSkeletonLoad] = useState(true);
  const skeletonArray = Array.from({ length: 8 }, (_, index) => index);
  const { wishlistCount, setWishlistCount } = useContext(CartContext);
  const [messageApi, contextHolder] = message.useMessage();
  const { setLoginModal } = useContext(LoginContext);
  const navigate = useNavigate()
  const getAllCategory = () => {
    setSkeletonLoad(true);
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(
      process.env.REACT_APP_HAPS_MEDIA_BASE_URL + "admin/getHomeZoneAppliances",
      // "/admin/getHomeZoneAppliances",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        // console.log('result',result);
        if (result.status === 200) {
          setData(result.data);
          setSkeletonLoad(false);
        }
      })
      .catch((error) => console.log("error", error));
  };

  useEffect(() => {
    getAllCategory();
  }, []);

  useEffect(() => {
    window.scroll(0, 0);
  }, [isLogin]);

  const [Pincode, setPincode] = useState("");

  // const handleGetMyLocation = async () => {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       async (position) => {
  //         try {
  //           const response = await fetch(
  //             `https://nominatim.openstreetmap.org/reverse?format=json&lat=${position.coords.latitude}&lon=${position.coords.longitude}`
  //           );
  //           const data = await response.json();
  //           // console.log(data);
  //           setPincode(data);
  //         } catch (error) {
  //           // console.log(error);
  //         }
  //       },
  //       (error) => {
  //         console.log(error);
  //       }
  //     );
  //   } else {
  //     console.log("Geolocation is not supported by this browser.");
  //   }
  // };

  // useEffect(() => {
  //   handleGetMyLocation();
  // }, []);

  const [bestDealData, setBestDealDData] = useState([]);
  const skeletonForBestDealArray = Array.from(
    { length: 10 },
    (_, index) => index
  );

  const getBestDeals = async () => {
    setSkeletonLoad(true);
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    await fetch(
      process.env.REACT_APP_HAPS_MEDIA_BASE_URL + "general/getBestDeal",
      // "/general/getBestDeal",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        if (result.status === 200) {
          setBestDealDData(result.data);
          setSkeletonLoad(false);
        }
      })
      .catch((error) => console.log("error", error));
  };

  const [OfferBanner, setOfferBanner] = useState();
  const getBanners = async () => {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    await fetch(
      process.env.REACT_APP_HAPS_MEDIA_BASE_URL + "Offers/getOffersById/16",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        // console.warn(result);
        if (result.status === 200) {
          setOfferBanner(result.offers);
        }
      })
      .catch((error) => console.log("error", error));
  };

  useEffect(() => {
    getBestDeals();
    getBanners();
  }, []);

  const handleHeartClick = async (id) => {
    if (isLogin === false) {
      setLoginModal(true);
    } else {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        product_id: id,
        customer_id: localStorage.getItem("CID"),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(
        process.env.REACT_APP_HAPS_MEDIA_BASE_URL + "wishlist/wishlistcreate",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          console.log(result);
          if (result.status === 200) {
            setWishlistCount(parseInt(wishlistCount + 1));
            getBestDeals();
            success();
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  const deleted = () => {
    messageApi.error("Removed From Wishlist!");
  };
  const success = () => {
    messageApi.success("Added To Wishlist!");
  };
  const handleDeleteWishlist = async (el) => {
    var requestOptions = {
      method: "DELETE",
      redirect: "follow",
    };

    await fetch(
      process.env.REACT_APP_HAPS_MEDIA_BASE_URL +
      `wishlist/deletewishlist/${el.whishlist_id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          setWishlistCount(parseInt(wishlistCount - 1));
          getBestDeals();
          deleted();
          // setLoading(false);
        }
      })
      .catch((error) => console.log("error", error));
  };

  return (
    <Container className="mt-2 md:mt-2 lg:mt-0 error-message">
      {contextHolder}
      <LandingCarousal />
      <section className="text-left sm:text-center m-4 sm:mt-4 bg-gradient-to-r from-blue-500 to-teal-400 py-10 rounded-xl sm:rounded-full shadow-lg text-white hover:shadow-xl transition duration-500 transform hover:scale-105 hover:bg-gradient-to-r hover:from-teal-500 hover:to-blue-400 sm:px-6 px-4 mb-6 sm:mb-8">
        <h2 className="text-3xl sm:text-4xl font-bold mb-4 transition duration-300 transform hover:translate-x-2 hover:scale-110">
          Transform Your Space with Expert Interior Design.
        </h2>
        <p className="text-base sm:text-lg mb-6 sm:px-0 transition duration-300 ease-in-out hover:text-gray-200">
          Elevate your home or office with personalized interior design solutions. From concept to completion, we create spaces that inspire. Contact us today!
        </p>
        <div className="flex justify-start sm:justify-center">
          <button onClick={() => navigate('/fina-interior-home+interior+services')} className="px-6 py-3 bg-white text-blue-600 font-semibold rounded-lg hover:bg-gray-200 transition duration-300 ease-in-out transform hover:scale-110 w-full sm:w-auto">
            Get Started Now
          </button>
        </div>
      </section>
      {/* <section className="text-left sm:text-center m-4 sm:mt-4 bg-gradient-to-r from-blue-500 to-teal-400 py-10 rounded-xl sm:rounded-full shadow-lg text-white hover:shadow-xl transition duration-500 transform hover:scale-105 hover:bg-gradient-to-r hover:from-teal-500 hover:to-blue-400 sm:px-6 px-4 mb-6 sm:mb-8">
        <h2 className="text-3xl sm:text-4xl font-bold mb-4 transition duration-300 transform hover:translate-x-2 hover:scale-110">
          Discover Elegance with Professional Interior Design.
        </h2>
        <p className="text-base sm:text-lg mb-6 sm:px-0 transition duration-300 ease-in-out hover:text-gray-200">
          Looking for a brochure-worthy transformation? Our team brings creativity and precision to every project, ensuring stunning results for your home or office. Let's make your vision a reality!
        </p>
        <div className="flex justify-start sm:justify-center">
          <button  onClick={() => window.open("https://arrangefree.com/backend/public/uploads/Arrange_free.pdf", "_blank")} className="px-6 py-3 bg-white text-blue-600 font-semibold rounded-lg hover:bg-gray-200 transition duration-300 ease-in-out transform hover:scale-110 w-full sm:w-auto">
            Explore Brochures
          </button>
        </div>
      </section> */}

      <section className="text-left sm:text-center m-4 sm:mt-4 bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 py-10 rounded-xl sm:rounded-full shadow-lg text-white hover:shadow-xl transition duration-500 transform hover:scale-105 hover:bg-gradient-to-r hover:from-pink-500 hover:to-red-400 sm:px-6 px-4 mb-6 sm:mb-8">
        <h2 className="text-3xl sm:text-4xl font-bold mb-4 transition duration-300 transform hover:translate-x-2 hover:scale-110">
          Custom Furniture Tailored to Your Style
        </h2>
        <p className="text-base sm:text-lg mb-6 sm:px-0 transition duration-300 ease-in-out hover:text-gray-200">
          Discover handcrafted furniture designed to fit your space and reflect your personality. From concept to creation, we bring your vision to life. Get started today!
        </p>
        <div className="flex justify-start sm:justify-center">
          <button onClick={() => navigate('/contact-us')} className="px-6 py-3 bg-white text-purple-600 font-semibold rounded-lg hover:bg-gray-200 transition duration-300 ease-in-out transform hover:scale-110 w-full sm:w-auto">
            Get Started Now
          </button>
        </div>
      </section>

      <section className="text-left sm:text-center m-4 sm:mt-4 bg-gradient-to-r from-blue-500 via-green-500 to-teal-500 py-10 rounded-xl sm:rounded-full shadow-lg text-white hover:shadow-xl transition duration-500 transform hover:scale-105 hover:bg-gradient-to-r hover:from-green-500 hover:to-teal-400 sm:px-6 px-4 mb-6 sm:mb-8">
        <h2 className="text-3xl sm:text-4xl font-bold mb-4 transition duration-300 transform hover:translate-x-2 hover:scale-110">
          Categories
        </h2>
        <p className="text-base sm:text-lg mb-6 sm:px-0 transition duration-300 ease-in-out hover:text-gray-200">
          Browse our wide range of services, including interior design, custom furniture, space planning, color consultation, and more. Find the perfect solution for your space!
        </p>
        <div className="flex justify-start sm:justify-center">
          <button onClick={() => navigate('/fina-interior-categories')} className="px-6 py-3 bg-white text-blue-600 font-semibold rounded-lg hover:bg-gray-200 transition duration-300 ease-in-out transform hover:scale-110 w-full sm:w-auto">
            Explore Our Categories
          </button>
        </div>
      </section>



      {/* <div className="my-10">
        <h1 className="text-xl md:text-2xl text-center text-gray-800 tracking-wider">
          Step Inside a World of Home Interiors{" "}
          <span className="text-xl md:text-2xl font-extrabold text-[#027100]">
            Browse by Categories
          </span>
        </h1>
        <CategoryCards
          linkTo="/sub-category"
          data={data}
          SkeletonLoad={SkeletonLoad}
          skeletonArray={skeletonArray}
          className="grid grid-cols-3 md:grid-cols-5 xl:grid-cols-8 gap-x-[10px] md:gap-x-[50px] gap-y-1 md:gap-y-4 cursor-pointer"
        />
      </div> */}
      <a href="/fina-interior-home+interior+services" className="block">
        <Banner bannerImage={OfferBanner} className="mx-2 xl:mx-0" />
      </a>
      {/* <MainPageFeatures /> */}
      <Catlog />
      {/* <MainPageTestimonials /> */}
      <Heading spanHeading={`Top Bargains`} />
      <SectDescription SectDescription="Big savings, stylish spaces: explore 'Top Bargains' for your dream home interiors." />
      <TopBargains
        bestDealData={bestDealData}
        skeletonForBestDealArray={skeletonForBestDealArray}
        SkeletonLoad={SkeletonLoad}
        handleHeartClick={handleHeartClick}
        handleDeleteWishlist={handleDeleteWishlist}
      />
      <RecentlyVisited />
      <CategoryFooter Category={data} />
      {isLogin === true ? <RecentlyVisited2 ProductsPerView={10} /> : false}
      {/* <section className="bg-gray-50">
        <div className="mx-auto max-w-screen-xl px-4 py-12 lg:flex lg:h-1/2 lg:items-center">
          <div className="mx-auto max-w-xl text-center">
            <h1 className="text-3xl font-extrabold sm:text-5xl">
              Explore our app!
              <strong className="font-extrabold text-red-700 sm:block">
                Download now!
              </strong>
            </h1>
            <p className="mt-4 sm:text-xl/relaxed">
              Discover our mobile app for the best home interior experience!
            </p>
            <div className="mt-8 flex flex-wrap justify-center gap-4">
              <div className="flex justify-center items-center gap-5">
                <img
                  src="/images/social/appStore.jpeg"
                  alt=""
                  className="h-[50px] w-[150px] object-contain cursor-pointer transition-all ease-in-out duration-700 hover:scale-105"
                  onClick={() =>
                    window.open(
                      "https://apps.apple.com/in/app/dorfee/id6462861358"
                    )
                  }
                />
                <img
                  src="/images/social/googlePlay.jpeg"
                  alt=""
                  onClick={() =>
                    window.open(
                      "https://play.google.com/store/apps/details?id=com.arrange_free"
                    )
                  }
                  className="h-[50px] w-[150px] object-contain cursor-pointer transition-all ease-in-out duration-700 hover:scale-105"
                />
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </Container>
  );
};

export default Home;
